import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-231d238f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Imprimir", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Baixar títulos", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Descontar títulos", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sim", -1))
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = {
  role: "button",
  tabindex: "0",
  class: "ant-upload ant-upload-btn",
  style: {"min-height":"200px!important"}
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "ant-upload-drag-icon" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Por favor, aguarde...", -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "ant-upload-drag-icon" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Clique para selecionar ou arraste o arquivo de retorno até aqui.", -1))
const _hoisted_17 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_21 = { class: "ant-col ant-col-xs-15 ant-col-xl-15" }
const _hoisted_22 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_23 = { class: "ant-row ss-grade-personalizada" }
const _hoisted_24 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ocorrência", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-2 ant-col-xl-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Nº do Título")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-3 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Pagador")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-2 ant-col-xl-2 ss-alinhar-texto-centro" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Vencimento")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-2 ant-col-xl-2 ss-alinhar-texto-direita" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Vlr do Título")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-2 ant-col-xl-2 ss-alinhar-texto-direita" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Taxas/Despesas")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-2 ant-col-xl-2 ss-alinhar-texto-direita" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Descontos")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-2 ant-col-xl-2 ss-alinhar-texto-direita" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Juros/Multa")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-2 ant-col-xl-2 ss-alinhar-texto-direita" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Valor Pago")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-2 ant-col-xl-2 ss-alinhar-texto-centro" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Status")
], -1))
const _hoisted_35 = { class: "ss-grade-personalizada-scroll ss-desabilitar-rolagem-horizontal" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "ant-col ant-col-xs-5 ant-col-5" }
const _hoisted_38 = { class: "ss-margin-campos" }
const _hoisted_39 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_40 = { class: "ss-margin-campos" }
const _hoisted_41 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_42 = { class: "ss-margin-campos" }
const _hoisted_43 = { class: "ant-col ant-col-xs-2 ant-col-xl-2 ss-alinhar-texto-centro" }
const _hoisted_44 = { class: "ss-margin-campos" }
const _hoisted_45 = { class: "ant-col ant-col-xs-2 ant-col-xl-2 ss-alinhar-texto-direita" }
const _hoisted_46 = { class: "ss-margin-campos" }
const _hoisted_47 = { class: "ant-col ant-col-xs-2 ant-col-xl-2 ss-alinhar-texto-direita" }
const _hoisted_48 = { class: "ss-margin-campos" }
const _hoisted_49 = { class: "ant-col ant-col-xs-2 ant-col-xl-2 ss-alinhar-texto-direita" }
const _hoisted_50 = { class: "ss-margin-campos" }
const _hoisted_51 = { class: "ant-col ant-col-xs-2 ant-col-xl-2 ss-alinhar-texto-direita" }
const _hoisted_52 = { class: "ss-margin-campos" }
const _hoisted_53 = { class: "ant-col ant-col-xs-2 ant-col-xl-2 ss-alinhar-texto-direita" }
const _hoisted_54 = { class: "ss-margin-campos" }
const _hoisted_55 = {
  class: "ant-col ant-col-xs-2 ant-col-xl-2 ss-alinhar-texto-centro",
  style: {"padding-left":"15px"}
}
const _hoisted_56 = {
  key: 0,
  class: "ss-painel-titulo ss-efeito-vidro ss-fadein-rapido"
}
const _hoisted_57 = { class: "ant-row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ant-modal-title",
  style: {"margin-left":"10px"}
}, "Detalhes do Retorno", -1))
const _hoisted_59 = {
  class: "ant-row",
  style: {"max-height":"calc(100% - 30px)","overflow-y":"auto"}
}
const _hoisted_60 = { class: "ant-row" }
const _hoisted_61 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_62 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_63 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_64 = ["value"]
const _hoisted_65 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_66 = ["value"]
const _hoisted_67 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_68 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_69 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_70 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_71 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_72 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_73 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_74 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_75 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sim", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sim", -1))
const _hoisted_78 = { class: "ant-row" }
const _hoisted_79 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_80 = ["value"]
const _hoisted_81 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_82 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_83 = ["value"]
const _hoisted_84 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_85 = ["value"]
const _hoisted_86 = { class: "ant-col ant-col-xs-18 ant-col-xl-18" }
const _hoisted_87 = ["value"]
const _hoisted_88 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_89 = { class: "ant-row" }
const _hoisted_90 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_91 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_92 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_93 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_94 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nenhum título vinculado foi encontrado.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_selecionar_generico = _resolveComponent("selecionar-generico")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_buscar_titulos_modal = _resolveComponent("buscar-titulos-modal")!
  const _component_movimento_financeiro_modal = _resolveComponent("movimento-financeiro-modal")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: "Importação de Retorno Bancário",
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "100%",
    centered: "",
    "wrap-class-name": "scroll-modal ss-modal-financeiro",
    maskClosable: false
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        (_ctx.state.retornos !== undefined && _ctx.state.retornos.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-secondary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imprimir && _ctx.imprimir(...args)))
            }, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmarBaixa && _ctx.confirmarBaixa(...args)))
        }, _hoisted_4),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmarDesconto && _ctx.confirmarDesconto(...args)))
        }, _hoisted_6)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.state.cacheDisponivel)
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 0,
                    type: "warning",
                    style: {"width":"100%"},
                    "show-icon": "",
                    closable: ""
                  }, {
                    message: _withCtx(() => [
                      _createTextVNode(" Você possui a importação do arquivo: " + _toDisplayString(_ctx.state.nomeArquivo) + " em andamento, deseja recuperar? ", 1),
                      _createVNode(_component_a_button, {
                        onClick: _ctx.recuperarCache,
                        size: "small",
                        type: "text"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_selecionar_conta, {
                  empresas: [_ctx.props.empresa],
                  codigoSelecionado: _ctx.state.codigoConta,
                  "onUpdate:codigoSelecionado": [
                    _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.codigoConta) = $event)),
                    _ctx.buscarConta
                  ]
                }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado"])
              ])
            ]),
            _createVNode(_component_a_collapse, {
              ghost: "",
              class: "ss-accordion",
              activeKey: _ctx.state.painelUpload,
              "onUpdate:activeKey": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.painelUpload) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_panel, {
                  key: "1",
                  header: "Envie um arquivo"
                }, {
                  default: _withCtx(() => [
                    (_ctx.modalBase.computedVisivel)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.selecionarArquivoUpload && _ctx.selecionarArquivoUpload(...args))),
                          class: "ant-upload ant-upload-drag",
                          onDragover: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
                          onDrop: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
                        }, [
                          _createElementVNode("span", _hoisted_10, [
                            _createElementVNode("input", {
                              id: "selecionarArquivo",
                              type: "file",
                              accept: "",
                              multiple: "",
                              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.uploadArquivoSelecionado && _ctx.uploadArquivoSelecionado(...args))),
                              style: {"display":"none"}
                            }, null, 32),
                            _createElementVNode("div", {
                              class: "ant-upload-drag-container",
                              onDrop: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.uploadArquivoArrastado && _ctx.uploadArquivoArrastado(...args)))
                            }, [
                              ((_ctx.state.enviandoArquivo))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createElementVNode("p", _hoisted_12, [
                                      _createVNode(_component_a_spin, { size: "large" })
                                    ]),
                                    _hoisted_13
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("p", _hoisted_15, [
                                      _createVNode(_component_icone, {
                                        style: {"font-size":"40px"},
                                        nome: "upload-nuvem"
                                      })
                                    ]),
                                    _hoisted_16
                                  ]))
                            ], 32)
                          ])
                        ], 32))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"])
          ]),
          (_ctx.state.retornos.length > 0 && !_ctx.state.enviandoArquivo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_card, { titulo: "Movimentações no Arquivo" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_a_form_item, {
                            label: "Tipo de Ocorrência",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_generico, {
                                itens: _ctx.state.tiposOcorrencia,
                                valor: _ctx.state.tipoOcorrenciaSelecionado,
                                "onUpdate:valor": [
                                  _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.tipoOcorrenciaSelecionado) = $event)),
                                  _ctx.filtrarOcorrencias
                                ]
                              }, null, 8, ["itens", "valor", "onUpdate:valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_a_form_item, {
                            label: "Busca Rápida",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
                                onKeyup: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.filtrarOcorrencias && _ctx.filtrarOcorrencias(...args)))
                              }, null, 544), [
                                [_vModelText, _ctx.state.buscaRapida]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_checkbox, {
                                checked: _ctx.state.ignorarTaxas,
                                "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.ignorarTaxas) = $event)),
                                onChange: _ctx.ignorarTaxas
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Ignorar Taxas")
                                ]),
                                _: 1
                              }, 8, ["checked", "onChange"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_a_checkbox, {
                            style: {"margin-left":"10px","margin-right":"5px"},
                            checked: _ctx.state.selecionarTodos,
                            "onUpdate:checked": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.selecionarTodos) = $event)),
                            onClick: _ctx.selecionarTodos
                          }, null, 8, ["checked", "onClick"]),
                          _hoisted_25
                        ]),
                        _hoisted_26,
                        _hoisted_27,
                        _hoisted_28,
                        _hoisted_29,
                        _hoisted_30,
                        _hoisted_31,
                        _hoisted_32,
                        _hoisted_33,
                        _hoisted_34
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.retornos, (retorno, index) => {
                          return _withDirectives((_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "ant-row ss-grade-personalizada-linha",
                            onClick: ($event: any) => (_ctx.selecionarRetorno(index))
                          }, [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_a_checkbox, {
                                style: {"margin-left":"5px"},
                                checked: _ctx.state.indexSelecionados.some((i) => i === index),
                                onClick: ($event: any) => (_ctx.alterarSelecao(index)),
                                disabled: retorno.status === _ctx.EStatusRetornoBancario.Baixado || retorno.status === _ctx.EStatusRetornoBancario.NaoEncontrado || (retorno.carteira !== 4 && retorno.codigoOcorrencia !== 6) || (retorno.carteira === 4 && retorno.codigoOcorrencia !== 2 && retorno.codigoOcorrencia !== 6)
                              }, null, 8, ["checked", "onClick", "disabled"]),
                              _createElementVNode("span", _hoisted_38, _toDisplayString('[' + _ctx.UtilitarioData.aplicaFormatoData(retorno.dataOcorrencia) + '] ' + retorno.descricaoOcorrencia), 1)
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("span", _hoisted_40, _toDisplayString(retorno.numeroDocumento), 1)
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("span", _hoisted_42, _toDisplayString(retorno.nomePagador === undefined || retorno.nomePagador === '' ? 'Desconhecido' : retorno.nomePagador), 1)
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(retorno.dataVencimento)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(retorno.valorTitulo)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(retorno.valorTaxas +
                      retorno.valorDespesas + retorno.valorOutrasDespesas)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(retorno.valorDescontos +
                      retorno.valorOutrosCreditos + retorno.valorAbatimento)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(retorno.valorJurosMulta)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(retorno.valorPago)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              (retorno.codigoOcorrencia === 6)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    ((retorno.status === _ctx.EStatusRetornoBancario.Baixado))
                                      ? (_openBlock(), _createBlock(_component_a_tag, {
                                          key: 0,
                                          class: "ss-tag-verde",
                                          style: {"width":"100%"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Baixado")
                                          ]),
                                          _: 1
                                        }))
                                      : ((retorno.status === _ctx.EStatusRetornoBancario.Pendente))
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 1,
                                            class: "ss-tag-laranja",
                                            style: {"width":"100%"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Pendente")
                                            ]),
                                            _: 1
                                          }))
                                        : ((retorno.status === _ctx.EStatusRetornoBancario.Descontado))
                                          ? (_openBlock(), _createBlock(_component_a_tag, {
                                              key: 2,
                                              class: "ss-tag-laranja",
                                              style: {"width":"100%"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Descontado")
                                              ]),
                                              _: 1
                                            }))
                                          : ((retorno.status === _ctx.EStatusRetornoBancario.Negativado))
                                            ? (_openBlock(), _createBlock(_component_a_tag, {
                                                key: 3,
                                                class: "ss-tag-roxo",
                                                style: {"width":"100%"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Negativado")
                                                ]),
                                                _: 1
                                              }))
                                            : ((retorno.status === _ctx.EStatusRetornoBancario.Protestado))
                                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                                  key: 4,
                                                  class: "ss-tag-roxo",
                                                  style: {"width":"100%"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Protestado")
                                                  ]),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createBlock(_component_a_tag, {
                                                  key: 5,
                                                  class: "ss-tag-vermelho",
                                                  style: {"width":"100%"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Indefinido")
                                                  ]),
                                                  _: 1
                                                }))
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ], 8, _hoisted_36)), [
                            [_vShow, retorno.visivel]
                          ])
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.indexSelecionado > -1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("a", {
                          style: {"font-size":"larger","font-weight":"bolder","margin-left":"10px","margin-top":"2px"},
                          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.fecharSelecao && _ctx.fecharSelecao(...args)))
                        }, [
                          _createVNode(_component_icone, {
                            style: {"color":"black"},
                            nome: "voltar"
                          })
                        ]),
                        _hoisted_58
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createVNode(_component_card, {
                          titulo: "DADOS PRINCIPAIS",
                          style: {"background-color":"white","margin":"5px"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _createVNode(_component_a_form_item, {
                                  label: "Dt da Ocorrência",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_data, {
                                      "data-selecionada": _ctx.state.retornoSelecionado.dataOcorrencia,
                                      "onUpdate:dataSelecionada": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.retornoSelecionado.dataOcorrencia) = $event)),
                                      disabled: true
                                    }, null, 8, ["data-selecionada"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_62, [
                                _createVNode(_component_a_form_item, {
                                  label: "Dt do Crédito",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_data, {
                                      "data-selecionada": _ctx.state.retornoSelecionado.dataCredito,
                                      "onUpdate:dataSelecionada": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.retornoSelecionado.dataCredito) = $event)),
                                      disabled: true
                                    }, null, 8, ["data-selecionada"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_63, [
                                _createVNode(_component_a_form_item, {
                                  label: "Nosso Número",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("input", {
                                      class: "ant-input",
                                      type: "text",
                                      value: _ctx.state.retornoSelecionado.nossoNumero,
                                      disabled: ""
                                    }, null, 8, _hoisted_64)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_65, [
                                _createVNode(_component_a_form_item, {
                                  label: "Ocorrência",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("input", {
                                      class: "ant-input",
                                      type: "text",
                                      value: _ctx.state.retornoSelecionado.descricaoOcorrencia,
                                      disabled: ""
                                    }, null, 8, _hoisted_66)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_67, [
                                _createVNode(_component_a_form_item, {
                                  label: "Vlr Abatimento",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      "quantidade-casas-decimais": 2,
                                      valor: _ctx.state.retornoSelecionado.valorAbatimento,
                                      "onUpdate:valor": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.retornoSelecionado.valorAbatimento) = $event)),
                                      disabled: false
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_68, [
                                _createVNode(_component_a_form_item, {
                                  label: "Vlr Descontos",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      "quantidade-casas-decimais": 2,
                                      valor: _ctx.state.retornoSelecionado.valorDescontos,
                                      "onUpdate:valor": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.retornoSelecionado.valorDescontos) = $event)),
                                      disabled: _ctx.state.retornoSelecionado.status === _ctx.EStatusRetornoBancario.Baixado
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_69, [
                                _createVNode(_component_a_form_item, {
                                  label: "Vlr Despesas",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      "quantidade-casas-decimais": 2,
                                      valor: _ctx.state.retornoSelecionado.valorDespesas,
                                      "onUpdate:valor": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.retornoSelecionado.valorDespesas) = $event)),
                                      disabled: true
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_70, [
                                _createVNode(_component_a_form_item, {
                                  label: "Vlr Outros Créditos",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      "quantidade-casas-decimais": 2,
                                      valor: _ctx.state.retornoSelecionado.valorOutrosCreditos,
                                      "onUpdate:valor": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.retornoSelecionado.valorOutrosCreditos) = $event)),
                                      disabled: true
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_71, [
                                _createVNode(_component_a_form_item, {
                                  label: "Vlr Juros/Multa",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      "quantidade-casas-decimais": 2,
                                      valor: _ctx.state.retornoSelecionado.valorJurosMulta,
                                      "onUpdate:valor": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.retornoSelecionado.valorJurosMulta) = $event)),
                                      disabled: _ctx.state.retornoSelecionado.status === _ctx.EStatusRetornoBancario.Baixado
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_72, [
                                _createVNode(_component_a_form_item, {
                                  label: "Vlr Outras Despesas",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      "quantidade-casas-decimais": 2,
                                      valor: _ctx.state.retornoSelecionado.valorOutrasDespesas,
                                      "onUpdate:valor": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.retornoSelecionado.valorOutrasDespesas) = $event)),
                                      disabled: true
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_73, [
                                _createVNode(_component_a_form_item, {
                                  label: "Valor Taxas",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      "quantidade-casas-decimais": 2,
                                      valor: _ctx.state.retornoSelecionado.valorTaxas,
                                      "onUpdate:valor": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.retornoSelecionado.valorTaxas) = $event)),
                                      disabled: true
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_74, [
                                _createVNode(_component_a_form_item, {
                                  label: "Valor Pago",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      "quantidade-casas-decimais": 2,
                                      valor: _ctx.state.retornoSelecionado.valorPago,
                                      "onUpdate:valor": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.retornoSelecionado.valorPago) = $event)),
                                      disabled: true
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_75, [
                                _createVNode(_component_a_form_item, {
                                  label: "Valor do Título",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      "quantidade-casas-decimais": 2,
                                      valor: _ctx.state.retornoSelecionado.valorTitulo,
                                      "onUpdate:valor": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.retornoSelecionado.valorTitulo) = $event)),
                                      disabled: true
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        (_ctx.state.apresentarSugestaoZerarDescontoEUsarAbatimento)
                          ? (_openBlock(), _createBlock(_component_a_alert, {
                              key: 0,
                              type: "info",
                              style: {"width":"100%"},
                              "show-icon": ""
                            }, {
                              message: _withCtx(() => [
                                _createTextVNode(" Você possui o total de R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.totalAbatimentosTituloSelecionado)) + " lançado como abatimento no Contas a Receber, deseja utiliza-lo e zerar o desconto? ", 1),
                                _createVNode(_component_a_button, {
                                  onClick: _ctx.usarAbatimentoEZerarDesconto,
                                  size: "small",
                                  type: "text"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_76
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.apresentarSugestaoPossivelJurosMulta())
                          ? (_openBlock(), _createBlock(_component_a_alert, {
                              key: 1,
                              type: "info",
                              style: {"width":"100%"},
                              "show-icon": ""
                            }, {
                              message: _withCtx(() => [
                                _createTextVNode(" Identificamos a possibilidade do título ter R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.valorJurosMultaSugestaoTituloSelecionado)) + " como Juros/Multa, deseja utilizar essa sugestão? ", 1),
                                _createVNode(_component_a_button, {
                                  onClick: _ctx.usarValorJurosMultaSugestao,
                                  size: "small",
                                  type: "text"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_77
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.state.retornoSelecionado.tituloFinanceiro !== undefined && _ctx.state.retornoSelecionado.tituloFinanceiro.codigo > 0)
                          ? (_openBlock(), _createBlock(_component_card, {
                              key: 2,
                              titulo: "DADOS DO TÍTULO",
                              style: {"background-color":"white","margin":"5px"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_78, [
                                  _createElementVNode("div", _hoisted_79, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Nº do Título",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("input", {
                                          class: "ant-input",
                                          type: "text",
                                          value: _ctx.state.retornoSelecionado.tituloFinanceiro.numeroTitulo,
                                          disabled: ""
                                        }, null, 8, _hoisted_80)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_81, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Dt do Vencimento",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_data, {
                                          "data-selecionada": _ctx.state.retornoSelecionado.tituloFinanceiro.dataVencimento,
                                          "onUpdate:dataSelecionada": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.retornoSelecionado.tituloFinanceiro.dataVencimento) = $event)),
                                          disabled: true
                                        }, null, 8, ["data-selecionada"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_82, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Tipo de Documento",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("input", {
                                          class: "ant-input",
                                          type: "text",
                                          value: _ctx.state.retornoSelecionado.tituloFinanceiro.descricaoTipoDocumentoFinanceiro,
                                          disabled: ""
                                        }, null, 8, _hoisted_83)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_84, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Pessoa",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("input", {
                                          class: "ant-input",
                                          type: "text",
                                          value: _ctx.state.retornoSelecionado.tituloFinanceiro.nomePessoa,
                                          disabled: ""
                                        }, null, 8, _hoisted_85)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_86, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Conta",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("input", {
                                          class: "ant-input",
                                          type: "text",
                                          value: _ctx.state.retornoSelecionado.tituloFinanceiro.descricaoConta,
                                          disabled: ""
                                        }, null, 8, _hoisted_87)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_88, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Valor do Título",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_campo_numerico, {
                                          monetario: true,
                                          "quantidade-casas-decimais": 2,
                                          valor: _ctx.state.retornoSelecionado.tituloFinanceiro.valorTotal,
                                          "onUpdate:valor": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.retornoSelecionado.tituloFinanceiro.valorTotal) = $event)),
                                          disabled: true
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                ((_ctx.state.retornoSelecionado.tituloSelecionadoManualmente && _ctx.state.retornos[_ctx.state.indexSelecionado].status != _ctx.EStatusRetornoBancario.Baixado))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "ss-botao-acao",
                                      onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.desvincularTitulo()))
                                    }, [
                                      _createVNode(_component_icone, { nome: "estornar" }),
                                      _createTextVNode("Remover título selecionado")
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.state.retornoSelecionado.tituloFinanceiro !== undefined && _ctx.state.retornoSelecionado.tituloFinanceiro.codigo > 0 && _ctx.state.retornoSelecionado.tituloFinanceiro.status !== _ctx.EStatusTituloFinanceiro.Baixado && _ctx.state.retornoSelecionado.codigoOcorrencia === 6)
                          ? (_openBlock(), _createBlock(_component_card, {
                              key: 3,
                              titulo: "DADOS DA BAIXA",
                              style: {"background-color":"white","margin":"5px"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_89, [
                                  _createElementVNode("div", _hoisted_90, [
                                    _createVNode(_component_a_form_item, {
                                      label: " ",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_checkbox, {
                                          checked: _ctx.state.retornoSelecionado.ignorarTaxas,
                                          "onUpdate:checked": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.retornoSelecionado.ignorarTaxas) = $event))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Ignorar Taxas")
                                          ]),
                                          _: 1
                                        }, 8, ["checked"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_91, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Categoria Principal",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_categoria_plano_conta, {
                                          "apresentar-numero": true,
                                          empresas: [_ctx.props.empresa],
                                          "tipo-plano-conta": 1,
                                          "codigo-selecionado": _ctx.state.retornoSelecionado.categoriaPrincipal,
                                          "onUpdate:codigoSelecionado": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.retornoSelecionado.categoriaPrincipal) = $event)),
                                          onChange: _ctx.salvarCache
                                        }, null, 8, ["empresas", "codigo-selecionado", "onChange"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_92, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Categoria de Multa/Juros",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_categoria_plano_conta, {
                                          "apresentar-numero": true,
                                          empresas: [_ctx.props.empresa],
                                          "tipo-plano-conta": 1,
                                          "codigo-selecionado": _ctx.state.retornoSelecionado.categoriaMultaJuros,
                                          "onUpdate:codigoSelecionado": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.retornoSelecionado.categoriaMultaJuros) = $event)),
                                          onChange: _ctx.salvarCache
                                        }, null, 8, ["empresas", "codigo-selecionado", "onChange"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (!_ctx.state.retornoSelecionado.ignorarTaxas)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                        _createVNode(_component_a_form_item, {
                                          label: "Categoria de Taxas",
                                          class: "ss-margin-campos"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_selecionar_categoria_plano_conta, {
                                              "apresentar-numero": true,
                                              empresas: [_ctx.props.empresa],
                                              "tipo-plano-conta": 1,
                                              "codigo-selecionado": _ctx.state.retornoSelecionado.categoriaTaxas,
                                              "onUpdate:codigoSelecionado": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.retornoSelecionado.categoriaTaxas) = $event)),
                                              onChange: _ctx.salvarCache
                                            }, null, 8, ["empresas", "codigo-selecionado", "onChange"])
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_94, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Categoria de Descontos",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_categoria_plano_conta, {
                                          "apresentar-numero": true,
                                          empresas: [_ctx.props.empresa],
                                          "tipo-plano-conta": 1,
                                          "codigo-selecionado": _ctx.state.retornoSelecionado.categoriaDescontos,
                                          "onUpdate:codigoSelecionado": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.retornoSelecionado.categoriaDescontos) = $event)),
                                          onChange: _ctx.salvarCache
                                        }, null, 8, ["empresas", "codigo-selecionado", "onChange"])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            }))
                          : ((_ctx.state.retornoSelecionado.tituloFinanceiro === undefined || _ctx.state.retornoSelecionado.tituloFinanceiro.codigo === 0) && _ctx.state.retornoSelecionado.codigoOcorrencia === 6)
                            ? (_openBlock(), _createBlock(_component_card, {
                                key: 4,
                                style: {"background-color":"white","margin":"5px"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_95,
                                  _createElementVNode("a", {
                                    class: "ss-botao-acao",
                                    onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.abrirBuscaTitulo && _ctx.abrirBuscaTitulo(...args)))
                                  }, [
                                    _createVNode(_component_icone, { nome: "pesquisar" }),
                                    _createTextVNode("Buscar título manualmente")
                                  ]),
                                  _createElementVNode("a", {
                                    onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.criarMovimentoFinanceiro && _ctx.criarMovimentoFinanceiro(...args))),
                                    class: "ss-botao-acao"
                                  }, [
                                    _createVNode(_component_icone, { nome: "novo" }),
                                    _createTextVNode("Criar um novo recebimento")
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.indexSelecionado > -1)
            ? (_openBlock(), _createBlock(_component_buscar_titulos_modal, {
                key: 1,
                "apenas-um-titulo": true,
                "apenas-titulos-pendentes": true,
                empresa: _ctx.state.conta.codigoEmpresa,
                "tipo-titulo": 2,
                "titulo-tela": 'Buscar Título no Contas a Receber com o valor total de R$ ' + _ctx.UtilitarioMascara.mascararValor(_ctx.state.retornoSelecionado.valorTitulo),
                visivel: _ctx.state.exibirBuscaTitulo,
                "onUpdate:visivel": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.exibirBuscaTitulo) = $event)),
                onConfirmacao: _ctx.vincularTitulo,
                valorTotalTituloEspecifico: _ctx.state.retornoSelecionado.valorTitulo
              }, null, 8, ["empresa", "titulo-tela", "visivel", "onConfirmacao", "valorTotalTituloEspecifico"]))
            : _createCommentVNode("", true),
          _createVNode(_component_movimento_financeiro_modal, {
            operacao: _ctx.state.operacaoLancamento,
            conta: _ctx.state.codigoConta,
            dataVencimento: _ctx.state.retornoSelecionado.dataVencimento,
            dataCompetencia: _ctx.UtilitarioData.obterDataAtual(),
            visivel: _ctx.state.exibirLancamento,
            "onUpdate:visivel": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.exibirLancamento) = $event)),
            movimentoPrePreenchido: _ctx.state.movimentoFinanceiroLancamento,
            onConfirmacao: _ctx.vincularMovimentoCriado
          }, null, 8, ["operacao", "conta", "dataVencimento", "dataCompetencia", "visivel", "movimentoPrePreenchido", "onConfirmacao"]),
          _createVNode(_component_requisicao_modal, {
            visivel: _ctx.modalBase.exibirRequisicaoModal,
            "onUpdate:visivel": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
            retornoRequisicao: _ctx.modalBase.retornoRequisicao,
            apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
            fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
          }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
        ]),
        _: 1
      }),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivosPdf
      }, null, 8, ["arquivos"])
    ]),
    _: 1
  }, 8, ["visible"]))
}